'use strict';

const _=require('pulsar-utils/dist-es6/_');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const Formatters=require('../../../../../dist-es6/client/formatters');
const DateBucketType=require('../../../../../dist-es6/client/features/fleetInsight/components/fleetIncidents/incidentBucketTypes').Types.Date;
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseFleetInsightSubViewController=require('../../../../../dist-es6/client/features/fleetInsight/components/baseFleetInsightSubViewController');let

FleetIncidentsDirective=class FleetIncidentsDirective extends BaseControllerBackedDirective{
get templateUrl(){
return'/templates/features/fleetInsight/components/fleetIncidentsTemplate';
}

get objectBindings(){
return['displayInterval'];
}

get controller(){
return FleetIncidentsDirectiveController;
}

get $inject(){
return[
'$timeout',
'$state',
'$scope',
'fleetIncidentsDataService',
'uncaughtErrorHandler',
'groupTreeService'];

}};


const AllTypes={
description:'All Incidents',
code:null};let


FleetIncidentsDirectiveController=class FleetIncidentsDirectiveController extends BaseFleetInsightSubViewController{
constructor($timeout,$state,$scope,fleetIncidentsDataService,uncaughtErrorHandler,groupTreeService){
super($state,$scope,fleetIncidentsDataService,uncaughtErrorHandler,groupTreeService);

this._localTimeZone=this._groupBasedDataService.localTimeZone;
this.selectedNotificationType=NotificationType.AllThresholdsExceeded;

$scope.$watch('controller.incidentTypes',(newIncidentTypes,oldIncidentTypes)=>{
if(!_.exists(newIncidentTypes)){
return;
}

const lastSelectedCode=_.get(this.selectedIncidentType,'code');
this.incidentTypesWithAll=[AllTypes].concat(newIncidentTypes);
if(_.exists(lastSelectedCode)){
this.selectedIncidentType=_.find(this.incidentTypesWithAll,{code:lastSelectedCode});
}
});

$scope.$watch('controller.selectedGroupData',(newSelectedGroup,oldSelectedGroup)=>{
if(!_.exists(newSelectedGroup)){
return;
}

for(const person of this.selectedGroupData.aggregatePersons){
for(const incident of person.incidents){

incident.currentlyScopedGroupMemberships=person.groupMembershipsAtScope;
}
}

this.allIncidents=_.flatten(this.selectedGroupData.aggregatePersons.map(p=>p.incidents));
this._updateFilteredIncidents();
});

$scope.$watch('controller.selectedIncidentType',(newSelectedIncidentType,oldSelectedIncidentType)=>{
this._updateFilteredIncidents();
});

this.filteredIncidents=this.allIncidents=[];
}

_updateFilteredIncidents(){
if(!_.exists(this.selectedIncidentType)){
return;
}

const{
bucketIndexMap:dateBucketIndexMap}=
DateBucketType.getAllBucketsWithInitialViewData(this.displayInterval,this._localTimeZone);



const _filter=this.selectedIncidentType===AllTypes?
i=>dateBucketIndexMap.has(DateBucketType.getBucketFor(i)):
i=>i.code===this.selectedIncidentType.code&&dateBucketIndexMap.has(DateBucketType.getBucketFor(i));

this.filteredIncidents=this.allIncidents.filter(_filter);
}

get displayInterval(){
return this._groupBasedDataService.displayInterval;
}

set displayInterval(unused){

}

get incidentTypes(){
return this._groupBasedDataService.incidentTypes;
}};


module.exports=FleetIncidentsDirective;
//# sourceMappingURL=fleetIncidentsDirective.js.map
